/**
 * Validates that any choice-type field values in `data` are among the allowed options
 * defined in the widget schema. Returns an error result if invalid, or null if all valid.
 */
export function validateChoiceFields(data, schema) {
    const errors = [];

    for (const field of schema.fields) {
        if (field.type !== 'choice' || data[field.name] == null) continue;

        const validValues = field.options.map((o) => o.value);
        if (!validValues.includes(data[field.name])) {
            errors.push(`Invalid value "${data[field.name]}" for "${field.name}". Valid options: ${validValues.join(', ')}`);
        }
    }

    if (errors.length) {
        return { success: false, error: errors.join('; ') };
    }

    return null;
}
